import styled from "styled-components";


export const PictureStyle = styled.img`
  max-width: 100%;
  height: auto;
`;

export const AvatarPicture = styled.img`
vertical-align: middle;
width: 100px;
height: 100px;
border-radius: 50%;
border:1px solid black;
margin: 10px;
`;
